import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";

import ErrorPage from "./pages/ErrorPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";

import RouteScrollToTop from "./helper/RouteScrollToTop";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css'; 


function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route exact path="/" element={<SignInPage />} /> {/*Signin Page */}
        <Route exact path="/bitmart" element={<HomePageOne />} />{" "}
        <Route exact path="/digifinex-vibe" element={<HomePageTwo />} />
        <Route exact path="/digifinex-spread" element={<HomePageThree />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="*" element={<ErrorPage />} />
      </Routes>
      <NotificationContainer />
    </BrowserRouter>
  );
}

export default App;
